// react
import React from "react";

// react-i18next
import { useTranslation } from "react-i18next";

// context
import { UserAuth } from "context/AuthContext";

// @mui
import { Grid, Typography, Divider, Stack } from "@mui/material";

// A ---------------------------------------------------------------------- M

const UserIdentityInfo = () => {
  const { user, clientData } = UserAuth();
  const { t } = useTranslation();

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant="body1" fontWeight={700} color="text.secondary" sx={{ mb: 1 }}>
          {t("information")}
        </Typography>
        <Divider sx={{ mb: 2, opacity: 0.4 }} />
      </Grid>

      <Grid item xs={12}>
        <Stack spacing={1}>
          <Typography variant="body2">
            <strong>{t("user_id")}</strong>: {user.uid || "N/A"}
          </Typography>

          <Typography variant="body2">
            <strong>{t("email")}</strong>: {user.email || "N/A"}
          </Typography>

          <Typography variant="body2">
            <strong>{t("company")}</strong>: {clientData ? clientData.companyName || clientData.id : "N/A"}
          </Typography>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default UserIdentityInfo;
